export enum AggregationFormula {
  count = "count",
  sum = "sum"
}

export enum AutomaticTax {
  failed = "failed",
  not_collecting = "not_collecting",
  supported = "supported",
  unrecognized_location = "unrecognized_location"
}

export enum BillingSchemeType {
  per_unit = "per_unit",
  tiered = "tiered"
}

export enum CancelFeedback {
  customer_service = "customer_service",
  low_quality = "low_quality",
  missing_features = "missing_features",
  other = "other",
  switched_service = "switched_service",
  too_complex = "too_complex",
  too_expensive = "too_expensive",
  unused = "unused"
}

export enum CancelReason {
  cancellation_requested = "cancellation_requested",
  payment_disputed = "payment_disputed",
  payment_failed = "payment_failed"
}

export enum CheckoutStatus {
  complete = "complete",
  expired = "expired",
  open = "open"
}

export enum CollectionMethod {
  charge_automatically = "charge_automatically",
  send_invoice = "send_invoice"
}

export enum CouponDuration {
  forever = "forever",
  once = "once",
  repeating = "repeating"
}

export enum EventTimeWindow {
  day = "day",
  hour = "hour"
}

export enum MeterStatus {
  active = "active",
  inactive = "inactive"
}

export enum PauseCollectionBehavior {
  keep_as_draft = "keep_as_draft",
  mark_uncollectible = "mark_uncollectible",
  void = "void"
}

export enum PaymentStatus {
  no_payment_required = "no_payment_required",
  paid = "paid",
  unpaid = "unpaid"
}

export enum PhaseCycleAnchor {
  automatic = "automatic",
  phase_start = "phase_start"
}

export enum PricingPlanInterval {
  day = "day",
  week = "week",
  month = "month",
  year = "year"
}

export enum PricingType {
  one_time = "one_time",
  recurring = "recurring"
}

export enum ProrationBehavior {
  always_invoice = "always_invoice",
  create_prorations = "create_prorations",
  none = "none"
}

export enum RecurringAggregateUsage {
  last_during_period = "last_during_period",
  last_ever = "last_ever",
  max = "max",
  sum = "sum"
}

export enum RecurringUsageType {
  metered = "metered",
  licensed = "licensed"
}

export enum ScheduleEndBehavior {
  cancel = "cancel",
  none = "none",
  release = "release",
  renew = "renew"
}

export enum ScheduleStatus {
  active = "active",
  canceled = "canceled",
  completed = "completed",
  not_started = "not_started",
  released = "released"
}

export enum SubscriptionStatus {
  trialing = "trialing",
  active = "active",
  canceled = "canceled",
  incomplete = "incomplete",
  incomplete_expired = "incomplete_expired",
  past_due = "past_due",
  unpaid = "unpaid",
  paused = "paused"
}

export enum TableType {
  assistant = "assistant",
  chat = "chat",
  collection = "collection",
  file = "file",
  folder = "folder",
  group = "group",
  model = "model",
  preset = "preset",
  profile = "profile",
  prompt = "prompt",
  provider = "provider",
  tenant = "tenant",
  tool = "tool",
  workspace = "workspace",
  mcp = "mcp"
}

export enum TaxBehavior {
  exclusive = "exclusive",
  inclusive = "inclusive",
  unspecified = "unspecified"
}

export enum TaxExempt {
  exempt = "exempt",
  none = "none",
  reverse = "reverse"
}

export enum TaxType {
  amusement_tax = "amusement_tax",
  communications_tax = "communications_tax",
  gst = "gst",
  hst = "hst",
  igst = "igst",
  jct = "jct",
  lease_tax = "lease_tax",
  pst = "pst",
  qst = "qst",
  retail_delivery_fee = "retail_delivery_fee",
  rst = "rst",
  sales_tax = "sales_tax",
  service_tax = "service_tax",
  vat = "vat"
}

export enum TiersModeType {
  graduated = "graduated",
  volume = "volume"
}

export enum TrialEndMissingPaymentMethod {
  cancel = "cancel",
  create_invoice = "create_invoice",
  pause = "pause"
}